module.exports = __webpack_public_path__ + "static/media/checkmark.0c579c3d.svg";